import React from "react";
import { useSelector } from "react-redux";
import PatientNotes from "./patient_notes/PatientNotes";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "components/pages/transmissions/modal/detail/notes/Notes.css";

import ClinicMrn from "components/pages/transmissions/modal/detail/notes/mrn/ClinicMrn";
import ReportTasks from "components/pages/transmissions/modal/detail/notes/task/ReportTasks";
import NotesFooter from "components/pages/transmissions/modal/detail/notes/footer/NotesFooter";

import ClinicNotes from "components/pages/transmissions/modal/detail/notes/clinic_notes/ClinicNotes";
import ReportNotes from "components/pages/transmissions/modal/detail/notes/report_notes/ReportNotes";

import { getRolePreference } from "utils/accountPreference";
import { getCurrentUserRole } from "utils/currentUser.util";
import { MAP_PREFERENCE_USER_ROLES } from "static/preferences";
import EHRNotes from "./ehr_notes/EHRNotes";
import ClinicNotesWithProviderNotes from "./clinic_note_with_provider_note/ClinicNotesWithProviderNotes";

const Notes = ({ data, isFetching }) => {
  const role = localStorage.getItem("role");
  const currentUserRole = getCurrentUserRole();
  const userRole = MAP_PREFERENCE_USER_ROLES[currentUserRole];

  const clinicName = data?.account;
  let physician = localStorage.getItem("physician") === "true";

  const { reportAccountDetail } = useSelector((state) => state.transmission);
  const { account } = useSelector((state) => state.accountPreference);
  const { accountsMapper } = useSelector((state) => state.account);
  const showClinicNotesWithProviderNotes =
    accountsMapper?.[data?.account]?.settings
      ?.show_clinic_notes_with_provider_notes;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="view-pdf__notes-wrapper">
        <div className="view-pdf__notes">
          <PatientNotes data={data && data} />
          <ReportNotes data={data && data} role={role} />

          {data?.transmissionType !== "connectivityStatus" &&
            (showClinicNotesWithProviderNotes ? (
              <ClinicNotesWithProviderNotes data={data && data} />
            ) : (
              <ClinicNotes
                data={data && data}
                role={role}
                clinicName={clinicName}
                physician={physician}
              />
            ))}

          <ClinicMrn data={data} role={role} clinicName={clinicName} />

          {reportAccountDetail?.settings?.show_ehr_notes && (
            <EHRNotes data={data} isFetching={isFetching} />
          )}

          {getRolePreference(account, "transmission_report", "tasks")?.includes(
            userRole
          ) && <ReportTasks data={data && data} isFetching={isFetching} />}
        </div>
        <NotesFooter data={data && data} />
      </div>
    </LocalizationProvider>
  );
};

export default Notes;
